import { CustomEventWithDetail, html, View } from 'rune-ts';
import klass from './ButtonFollow.module.scss';
import { myFanIconHeart } from '../../../../shared/components/atoms/Icon/foundation_icons';
import { classes } from '../../../../shared/util';
import { font } from '../../../../shared/typography';
import { each, filter, pipe } from '@fxts/core';
import { goLogin } from '@services/MarppleShop/shared/util/goLogin.ts';

export interface ButtonFollowProps {
  store_id: number;
  is_login: boolean;
  is_follow: boolean;
  withLabel: boolean;
  is_transparent?: boolean;
  klass?: typeof klass;
}

export class CreatorFollowToggleEvent extends CustomEventWithDetail<{
  is_liked: boolean;
  store_id: number;
  toggle: () => void;
}> {}

export class ButtonFollow extends View<ButtonFollowProps> {
  observer?: MutationObserver;

  protected override template() {
    const { is_follow, klass: inheritKlass, withLabel, is_transparent } = this.data;
    return html`
      <button
        type="button"
        class="${classes(
          {
            [klass.button_follow_without_label]: !withLabel,
            [klass.button_follow_with_label]: withLabel,
            [klass.button_follow_transparent]: is_transparent,
          },
          inheritKlass,
        )}"
        data-is-follow="${is_follow}"
      >
        <i data-is-fan>${myFanIconHeart({ color: 'blue' })}</i>
        <i data-is-not-fan>${myFanIconHeart({ color: 'gray50' })}</i>
        ${withLabel
          ? html`<span class="${klass.button_follow_label} ${font('10_medium')}"
              >${this.data.is_follow
                ? ET('creator_shop::profile::became')
                : ET('creator_shop::profile::become')}</span
            >`
          : ''}
      </button>
    `;
  }

  protected override onRender() {
    this.addEventListener('click', (event) => {
      event.stopPropagation();
      event.preventDefault();

      if (!this.data.is_login) return goLogin();

      this.dispatchEvent(CreatorFollowToggleEvent, {
        bubbles: true,
        detail: {
          is_liked: !this.data.is_follow,
          store_id: this.data.store_id,
          toggle: this.toggle.bind(this),
        },
      });
    });
  }

  protected override onMount() {
    this.observer = new MutationObserver((mutations) =>
      pipe(
        mutations,
        filter((mutation) => mutation?.type === 'attributes' && mutation?.attributeName === 'data-is-follow'),
        each(() => {
          const span = this.element().querySelector(`.${klass.button_follow_label}`);
          const isFollow = this.element().dataset.isFollow === 'true';
          if (span)
            span.textContent = isFollow
              ? ET('creator_shop::profile::became')
              : ET('creator_shop::profile::become');
        }),
      ),
    );

    this.observer.observe(this.element(), {
      attributes: true,
      attributeFilter: ['data-is-follow'],
    });
  }

  protected override onUnmount() {
    this.observer?.disconnect();
  }

  public toggle() {
    this.data.is_follow = !this.data.is_follow;
    this.element().setAttribute('data-is-follow', String(Boolean(this.data.is_follow)));
  }
}
